/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { backPageFlg, pageTitle } from '../../context/PageRecoil';
import { pathnames } from '../../api';
import useStyles from '../../css/style';
import { routeName } from '../../App';
import Parts from '../../models/data/Parts';
import { requestPartsDetail } from '../../api/parts';
import DataDisp from './datadisp';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  eqid: string;
  mstid: string;
  id: string;
};

/**
 * 部品詳細画面
 */
const PartsDetailPage: React.FunctionComponent = () => {
  const history = useHistory();
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { eqid, mstid, id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<Parts>(); // 表示するメインデータ
  const { errorCheck } = useErrorHandling(); // エラー処理

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '部品詳細' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlPartsDetail = history.createHref({
    pathname: pathnames.partsdetail,
  }); // 部品一覧取得URL

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestPartsDetail(urlPartsDetail, {
        eqId: Number(eqid),
        mstId: Number(mstid),
        partsId: Number(id),
      }),
    ])
      .then((responses) => {
        setData(responses[0].data); // 部品情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, partsList: true });
            history.push(`${routeName.partsList}/${eqid}/${mstid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={data} />
      </div>
    </LoadingOverlay>
  );
};

export default PartsDetailPage;
